<template>
  <mia-form @submit="save">
    <mia-form-section title="Pricing">
      <mia-form-section-grid>
        <!-- Accounting Base Rate -->
        <div>
          <mia-feature-input
            v-model="form.item_accounting_baserate"
            label="Monatliche Grundgebühr"
            type="number"
            min="0"
            addon="€"
            input-class="text-right"
            :errors="getErrors('item_accounting_baserate')"
            @input="clearErrors('item_accounting_baserate')"
          />
        </div>

        <!-- Accounting Car Price -->
        <div>
          <mia-feature-input
            v-model="form.item_accounting_car_price"
            label="Preis pro angelegtem Fahrzeug"
            type="number"
            min="0"
            addon="€"
            input-class="text-right"
            :errors="getErrors('item_accounting_car_price')"
            @input="clearErrors('item_accounting_car_price')"
          />
        </div>

        <!-- Accounting Cars Included -->
        <div>
          <mia-feature-input
            v-model="form.item_accounting_cars_included"
            label="Kostenlos enthaltene Fahrzeuge / Monat"
            type="number"
            min="0"
            input-class="text-right"
            :errors="getErrors('item_accounting_cars_included')"
            @input="clearErrors('item_accounting_cars_included')"
          />
        </div>
      </mia-form-section-grid>
    </mia-form-section>

    <template #actions>
      <div class="flex items-center justify-between w-full">
        <mia-section-progress
          group="settingsBasics"
          page="invoice"
          section="pricingData"
        />

        <mia-submit-button
          :disabled="$wait.any"
          :is-loading="$wait.is('updating invoice pricing data')"
        />
      </div>
    </template>
  </mia-form>
</template>

<script>
import { mapGetters } from 'vuex'
import { updateInvoicePricingData } from '@/api/settings'
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import SectionProgress from '@/components/cars/edit/SectionProgress.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import Form from '@/components/ui/widgets/Form.vue'
import FormSection from '@/components/ui/widgets/FormSection.vue'
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'

export default {
  name: 'MiaSettingsBasicsInvoicePricingForm',

  components: {
    'mia-feature-input': FeatureInput,
    'mia-form': Form,
    'mia-form-section': FormSection,
    'mia-form-section-grid': FormSectionGrid,
    'mia-section-progress': SectionProgress,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  data() {
    return {
      form: {
        item_accounting_baserate: 0,
        item_accounting_car_price: 0,
        item_accounting_cars_included: 0
      }
    }
  },

  computed: {
    ...mapGetters('settings', ['settings'])
  },

  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(settings) {
        this.$set(this.form, 'item_accounting_baserate', settings.item_accounting_baserate)
        this.$set(this.form, 'item_accounting_car_price', settings.item_accounting_car_price)
        this.$set(this.form, 'item_accounting_cars_included', settings.item_accounting_cars_included)
      }
    }
  },

  methods: {
    async save() {
      this.resetErrors()
      this.$wait.start('updating invoice pricing data')

      const [error] = await updateInvoicePricingData({
        item_accounting_baserate: this.form.item_accounting_baserate,
        item_accounting_car_price: this.form.item_accounting_car_price,
        item_accounting_cars_included: this.form.item_accounting_cars_included
      })

      this.$wait.end('updating invoice pricing data')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Fehler beim Speichern der Daten.']
        })

        this.handleBackendValidationErrors(error)
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Daten erfolgreich gespeichert.']
      })

      await this.$store.dispatch('settings/loadSettings')
    }
  }
}
</script>
